import { z } from "zod";

function isValidAbaRoutingNumber(value: string): boolean {
  if (!/^\d{9}$/.test(value) || value === "000000000") return false;
  const digits = [...value].map(Number);
  const checksum =
    3 * (digits[0] + digits[3] + digits[6]) +
    7 * (digits[1] + digits[4] + digits[7]) +
    (digits[2] + digits[5] + digits[8]);
  return checksum % 10 === 0;
}

export const usBankDetailsSchema = z.object({
  beneficiaryName: z.string().trim().min(1, "Name on bank account is required").max(140),
  bankName: z.string().trim().min(1, "Bank name is required").max(140),
  accountNumber: z.string().trim().regex(/^\d{4,17}$/, "Bank account number must contain 4 to 17 digits"),
  branchName: z.string().trim().max(140),
  routingNumber: z.string().trim().refine((value) => !value || isValidAbaRoutingNumber(value), "Enter a valid 9-digit ABA routing number"),
});

export type UsBankDetailsValues = z.infer<typeof usBankDetailsSchema>;

